module.exports = __webpack_public_path__ + "static/media/1f333.5ac1b0a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f333.svg
// module id = 648
// module chunks = 1